<script lang="ts" setup>
import type { FilterGroupMultiSelect } from "~~/models/filters";
import type { CatalogPageRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ cmsData: CatalogPageRecord }>();

const { loggedIn } = useUserSession();

const { status, searchState, activeFilters, pagination } = useCatalog({
  initialize: {
    searchState: false,
    catalog: false,
    ssr: !loggedIn.value,
    scrollIntoViewThreshold: 500,
  },
});

const isOpen = ref(false);
const slideoverCount = useIsSlideoverOpen();

watch(isOpen, (val) => {
  slideoverCount.value = val ? slideoverCount.value + 1 : Math.max(0, slideoverCount.value - 1);
});
</script>

<template>
  <div class="p-md gap-md flex flex-col rounded-md bg-neutral-50 lg:hidden">
    <LazyUSlideover v-model:open="isOpen" side="bottom" :ui="{ content: 'h-full' }">
      <div class="gap-xs flex cursor-pointer items-center " @click="isOpen = true">
        <UIcon name="i-ph-sliders-horizontal" class="text-lg" />
        <span class="text-primary text-[16px] underline">
          {{ cmsData.overviewFilterTextWithCount.replace("{count}", pagination.totalItems?.toString() ?? "0") }}</span>
      </div>

      <template #content>
        <div class="h-full bg-[#F8F7F4]">
          <div class="gap-md p-md flex h-full flex-col">
            <h6 class="text-[16px] font-bold">
              {{ cmsData.overviewFilterTitle }}
            </h6>

            <MultiSelectFilter
              v-for="filterGroup of searchState.propertyFilters" :key="filterGroup.title"
              :filter-group="filterGroup as FilterGroupMultiSelect" size="lg"
            />

            <ProductSearchSort size="lg" />

            <div class="mt-auto">
              <UButton variant="solid" color="primary" size="lg" class="w-full" :loading="status === 'pending'" @click="isOpen = false">
                {{ cmsData.overviewFilterTextWithCount.replace("{count}", pagination.totalItems?.toString() ?? "0") }}
              </UButton>
            </div>
          </div>
        </div>
      </template>
    </LazyUSlideover>

    <hr v-if="activeFilters.length" class="border-neutral-100">

    <ProductSearchFiltersActive v-if="activeFilters.length" :cms-data="cmsData" />
  </div>
</template>

<style scoped>

</style>
